module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"sortOptions":{"sort":"Sortieren","identifier":"Identifikation","description":"Bezeichnung","municipality":"Gemeinde","energy_area":"Fläche (EBF)","ee":"Endenergie","ghg":"Scope 1-2 Emissionen","building_year":"Baujahr"}}}')
  delete Component.options._Ctor
}
